import { Chip } from '@mui/material';

export function DepartmentBadge({ department }) {
  const getDepartmentStyle = (dept) => {
    switch (dept) {
      case 'Mathematics': return { bgcolor: '#e3f2fd', color: '#1976d2' };
      case 'Science': return { bgcolor: '#e8f5e9', color: '#2e7d32' };
      case 'English': return { bgcolor: '#fff3e0', color: '#ed6c02' };
      case 'Hindi': return { bgcolor: '#fce4ec', color: '#c2185b' };
      case 'Social Science': return { bgcolor: '#efebe9', color: '#5d4037' };
      case 'Computer Science': return { bgcolor: '#e0f7fa', color: '#0097a7' };
      case 'Physical Education': return { bgcolor: '#f3e5f5', color: '#7b1fa2' };
      default: return { bgcolor: '#f5f5f5', color: '#616161' };
    }
  };

  const style = getDepartmentStyle(department);

  return (
    <Chip
      label={department}
      size="small"
      sx={{
        bgcolor: style.bgcolor,
        color: style.color,
        fontWeight: 500,
        borderRadius: '4px',
      }}
    />
  );
}
